module.exports = __webpack_public_path__ + "img/17k.7ba413eb.svg";